module.exports = {
  title: '商品到货通知',
  route: {
    path: '/data-statistics',
    children: {
      path: 'goods-arrival-notice',
    },
  },
};
